export default __webpack_public_path__ + "static/media/FAVICON_50.0a106768.png";